import React, {Component} from 'react';
import { bindActionCreators } from 'redux';
import {connect} from 'react-redux';

import { PDFViewer, PDFDownloadLink } from '@react-pdf/renderer';
import { Page, Text, View, Document, StyleSheet, Image, Font } from '@react-pdf/renderer';
import {getCurrentMode, feedingGuidelinesMode, pdfStyles} from './../../helpers/FeedingGuidelinesHelper';

import {setOriginalDeviceViewport} from '../../helpers/ScreenshotHelper';
import * as actionTypes from './../../store/actions/feedingGuidelinesGenerateAction';
import * as pdfOutputAction from './../../store/actions/pdfOutputAction';

import {isMobile} from 'react-device-detect';

class PdfOutput extends Component {

  /**
   * Hides the loader
   *
   * @memberof PdfOutput
   */
  hideLoader(){
    const loader = document.getElementById("nppe2-fc-feeding-guidelines-outer__loader");
    if (loader){
      loader.style.display = "none";
    }
  }

  /**
   * Locks the body scrolling while the PDF modal is open
   *
   * @memberof PdfOutput
   */
  lockScrolling(){
    document.body.style.overflow = "hidden";
    document.getElementsByTagName('html')[0].style.overflow = "hidden";
  }

  /**
   * Unlocks the body scrolling while the PDF modal is closed
   *
   * @memberof PdfOutput
   */
  unlockScrolling(){
    document.body.style.overflow = "visible";
    document.getElementsByTagName('html')[0].style.overflow = "visible";
  }

  /**
   * Renders the component
   *
   * @returns JSX|null
   * @memberof PdfOutput
   */
  render() {
    const {images, closeFeedingGuidelines, clearFeedingGuidelinesImages, data, name, clinicRecordNumber, error} = this.props;

    if (error) {
      this.hideLoader();
      return (
        <div role="alert" aria-live="assertive" className="nppe2-fc-feeding-guidelines-outer__error">
          <p>{data.printErrorMessage}</p>
          <a href="#" aria-label={data.buttons.close} onClick={(e) => {
            e.preventDefault();
            this.unlockScrolling();
            closeFeedingGuidelines();
            clearFeedingGuidelinesImages();
          }}>{data.buttons.close}</a>
        </div>
      );
    }

    let imageKeys = Object.keys(images);

    const mode = getCurrentMode();
    if (!mode || !feedingGuidelinesMode[mode]) {
      return null;
    }

    const lookup = feedingGuidelinesMode[mode]["components"];

    let documentName = data.documentName + name;
    if (clinicRecordNumber !== null && typeof clinicRecordNumber !== "undefined"){
      documentName = data.documentName + name + "-" + clinicRecordNumber;
    }

    // Get easy reference to keys and styles
    let lookUpKeys = [];
    let lookUpStyles = [];
    let lookUpFixed = [];

    lookup.forEach(element => {
      lookUpKeys.push(element.key)
      lookUpStyles[element.key] = element.styles;
      lookUpFixed[element.key] = element.fixed;
    });

    if ( imageKeys.length === lookup.length ){
      this.lockScrolling();
      const pdfDocument = <Document onRender={this.hideLoader()} >
        <Page style={styles.page} wrap={true}>
          {lookUpKeys.map((value, index) => (
            <Image
              key={value}
              src={images[value]}
              style={lookUpStyles[value]}
              fixed={lookUpFixed[value]}/>
          ))}
        </Page>
      </Document>

      if (isMobile) {
        return (
          <div id="print-iframe-wrapper">
            <div className="print-iframe-wrapper__message">
              <p>{data.embedMessage}</p>

              <div className="nppe2-fc-feeding-guidelines-outer__controls-mobile">
                <ul  className="nppe2-fc-feeding-guidelines-outer__buttons-list-mobile">
                  <li>
                    <PDFDownloadLink
                      fileName={documentName}
                      document={pdfDocument}
                      children={data.buttons.download}/>
                  </li>

                  <li><a href="#" onClick={()=> {
                    this.unlockScrolling();
                    closeFeedingGuidelines();
                    clearFeedingGuidelinesImages();
                    setOriginalDeviceViewport();
                  }}>{data.buttons.close}</a></li>
                </ul>
              </div>
            </div>
          </div>
        );
      } else {
        return (
          <>
            <div id="print-iframe-wrapper">
              <PDFViewer>
                {pdfDocument}
              </PDFViewer>
            </div>

            <div className="nppe2-fc-feeding-guidelines-outer__controls">
              <ul  className="nppe2-fc-feeding-guidelines-outer__buttons-list">
                <li>
                  <PDFDownloadLink
                    fileName={documentName}
                    document={pdfDocument}
                    children={data.buttons.download}/>
                </li>
                <li>
                  <a href="#"
                    onClick={ () => {
                      const parent = window.document.getElementById("print-iframe-wrapper");
                      if (parent){
                        const frame = parent.getElementsByTagName("iframe");
                        if (frame[0]){
                          frame[0].contentWindow.print();
                        }
                      }
                    }}>
                      {data.buttons.print}
                    </a>
                </li>

                <li><a href="#" onClick={()=> {
                  this.unlockScrolling();
                  closeFeedingGuidelines();
                  clearFeedingGuidelinesImages();
                }}>{data.buttons.close}</a></li>
              </ul>
            </div>
          </>
        );
      }
    }

    return null;
  }
}

const mapStateToProps = state => {
  return {
    images: state.pdfOutputReducer.images,
    error: state.pdfOutputReducer.error,
  }
};

const mapDispatchToProps = dispatch => {
  return {
    clearFeedingGuidelinesImages: () => dispatch({
      type: pdfOutputAction.CLEAR_IMAGES,
    }),

    closeFeedingGuidelines: () => dispatch({
      type: actionTypes.HIDE_FEEDING_GUIDELINES,
    }),
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(PdfOutput);

const styles = StyleSheet.create(pdfStyles);
